export const timesheetStatusEnums = {
    OPEN:1,
    SUBMITTED:2,
    RE_OPEN:3,
    APPROVED:4,
    RE_SUBMITTED:5,
};
